var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { StackLayout, TextInput } from '@wemogy/reactbase';
import NominatimService from '../../../dataLayer/services/NominatimService';
var AddressInputImplementation = function (_a) {
    var specific = _a.specific, selectedAddress = _a.selectedAddress, onAddressSelected = _a.onAddressSelected;
    var _b = __read(useState(''), 2), query = _b[0], setQuery = _b[1];
    var _c = __read(useState(''), 2), city = _c[0], setCity = _c[1];
    var _d = __read(useState(''), 2), street = _d[0], setStreet = _d[1];
    var _e = __read(useState(''), 2), houseNumber = _e[0], setHouseNumber = _e[1];
    var _f = __read(useState(false), 2), isLoading = _f[0], setIsLoading = _f[1];
    var _g = __read(useState([]), 2), searchResults = _g[0], setSearchResults = _g[1];
    useEffect(function () {
        if (selectedAddress) {
            setCity(selectedAddress.city || '');
            setStreet(selectedAddress.street || '');
            setHouseNumber(selectedAddress.streetNumber || '');
        }
        else {
            setCity('');
            setStreet('');
            setHouseNumber('');
        }
    }, [selectedAddress]);
    var handleQueryChange = useCallback(_.debounce(function (newQuery, queryParam2, queryParam3) { return __awaiter(void 0, void 0, void 0, function () {
        var results, _a, addressResults, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 5, 6, 7]);
                    setIsLoading(true);
                    if (!specific) return [3 /*break*/, 2];
                    return [4 /*yield*/, new NominatimService().specificSearch(newQuery, queryParam2, queryParam3)];
                case 1:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, new NominatimService().freeSearch(newQuery)];
                case 3:
                    _a = _c.sent();
                    _c.label = 4;
                case 4:
                    results = _a;
                    addressResults = results.map(function (x) {
                        var address = x.address;
                        return ({
                            placeId: x.place_id,
                            label: x.display_name,
                            country: address.country,
                            city: address.village || address.city || address.town,
                            zipCode: address.postcode,
                            street: address.road,
                            streetNumber: address.house_number,
                            position: {
                                latitude: x.lat,
                                longitude: x.lon
                            }
                        });
                    });
                    setSearchResults(addressResults);
                    return [3 /*break*/, 7];
                case 5:
                    _b = _c.sent();
                    return [3 /*break*/, 7];
                case 6:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); }, 1000), [specific]);
    var handleAutocompleteResultSelected = useCallback(function (autocompleteResult) {
        onAddressSelected(autocompleteResult.reference);
    }, [onAddressSelected]);
    useEffect(function () {
        if (!query) {
            return;
        }
        handleQueryChange(query);
    }, [query]);
    useEffect(function () {
        handleQueryChange(city, street, houseNumber);
    }, [city, street, houseNumber]);
    var autocompleteResults = searchResults.map(function (x) { return ({
        key: x.placeId,
        title: x.label,
        reference: x
    }); });
    if (specific) {
        return (React.createElement(StackLayout, { horizontal: true },
            React.createElement(StackLayout, { stretch: true, marginRight: true },
                React.createElement(TextInput, { placeholder: "Stadt", value: city, onChange: setCity, autocompleteResults: autocompleteResults, onAutocompleteResultSelected: handleAutocompleteResultSelected, isLoading: isLoading })),
            React.createElement(StackLayout, { stretch: true, marginRight: true },
                React.createElement(TextInput, { placeholder: "Stra\u00DFe", value: street, onChange: setStreet, autocompleteResults: autocompleteResults, onAutocompleteResultSelected: handleAutocompleteResultSelected, isLoading: isLoading })),
            React.createElement(StackLayout, { stretch: true },
                React.createElement(TextInput, { placeholder: "Hausnummer", value: houseNumber, onChange: setHouseNumber, autocompleteResults: autocompleteResults, onAutocompleteResultSelected: handleAutocompleteResultSelected, isLoading: isLoading }))));
    }
    return (React.createElement(TextInput, { value: query, onChange: setQuery, autocompleteResults: autocompleteResults, onAutocompleteResultSelected: handleAutocompleteResultSelected, isLoading: isLoading }));
};
export default AddressInputImplementation;
//# sourceMappingURL=AddressInputImplementation.js.map